import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InfoIcon from "@mui/icons-material/Info";
import axios from "axios";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import ModalContent from "../../Common/Modal";
import InfoPopUp from "../../Common/InfoPopUp";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import { useTradingColors } from "../Spot/tradingColorConfig";
import "../MyWallet/mywallet.css";
import "../Spot/Spot.css";

const OPTIONSMARGINURL = WEBSERVICE + "/optionsMargin/";

const AssetSpotColumn = ["Asset", "Balance", "Action"];

const Infomodal = [
  {
    title: "Cross",
    description:
      "Cross Wallet is a crypto wallet built to hold multiple blockchain cryptocurrencies in one wallet.",
  },
  {
    title: "Crypto Holdings",
    description:
      "You can do margin and funding in your Cryptocurrency from this section.",
  },
  {
    title: "SPOT WALLET",
    description:
      "You can see your Crypto balance, transfer to margins, and fund your Crypto through SPOT WALLET.",
  },
  {
    title: "MARGIN",
    description:
      "You can see your margin wallet balance, used balance, and available margin wallet balance. You can transfer your margin wallet balance to your spot wallet through the transfer to SPOT button.",
  },
  {
    title: "VIEW MY FUNDINGS",
    description:
      "You can see your Fundings here by selecting currency and providing From Date and To Date.",
  },
  {
    title: "Transfer to SPOT",
    description:
      "You can transfer your margin wallet balance to the spot wallet through this SPOT button.",
  },
];

const OptionMarginHoldings = () => {
  const { btncolor } = useSelector((state) => state);
  const { upColor, pairButtonColor } = useTradingColors();
  const themeBtnColor = pairButtonColor || btncolor || "#1976d2";

  const [assetTab, setAssetTab] = useState("SPOT WALLET"); // "SPOT WALLET" | "MARGIN" | "VIEW MY FUNDINGS"
  const [currency, setCurrency] = useState("");
  const [assetCurrency, setAssetCurrency] = useState("");

  const [assetFromDate, setAssetFromDate] = useState(null);
  const [assetToDate, setAssetToDate] = useState(null);
  const [returnDate, setReturnDate] = useState(null);

  const [marginModal, setMarginModal] = useState(false);
  const [fundingModal, setFundingModal] = useState(false);
  const [marginSpotModal, setMarginSpotModal] = useState(false);
  const [customerFundingModal, setCustomerFundingModal] = useState(false);

  const [myBalanceListForOption, setMyBalanceListForOption] = useState([]);
  const [amount, setAmount] = useState(0);
  const [cryptoCurrency, setCryptoCurrency] = useState("");
  const [fiatCurrencyId, setFiatCurrencyId] = useState(null);

  const [sendAmount, setSendAmount] = useState("");
  const [sendAmountFunding, setSendAmountFunding] = useState("");
  const [sendAmountMargin, setSendAmountMargin] = useState("");

  const [fundingHomeViewCrossForOption, setFundingHomeViewCrossForOption] = useState([]);
  const [fundingHomeViewFundingForOption, setFundingHomeViewFundingForOption] = useState([]);

  const [marginWalletBalanceForOption, setMarginWalletBalanceForOption] = useState(0);
  const [usedBalanceForOption, setUsedBalanceForOption] = useState(0);
  const [availableBalanceForOption, setAvailableBalanceForOption] = useState(0);
  const [marginwalletIdForOption, setMarginwalletIdForOption] = useState(null);
  const [currencyIdForOption, setCurrencyIdForOption] = useState(null);
  const [cryptoCurrencyForOption, setCryptoCurrencyForOption] = useState(null);

  const [cryptoCur, setCryptoCur] = useState("");
  const [cryptoid, setCryptoid] = useState("");
  const [cryptomarginwalletId, setCryptomarginwalletId] = useState("");

  const [fundingData, setFundingData] = useState([]);
  const [infoModal, setInfoModal] = useState(false);
  const [infoIndex, setInfoIndex] = useState(0);

  const eventSourceRef = useRef(null);

  const assetLabels = ["SPOT WALLET", "MARGIN", "VIEW MY FUNDINGS"];

  const handleInfoModal = (index) => {
    setInfoIndex(index);
    setInfoModal(true);
  };
  const handleCloseInfoModal = () => setInfoModal(false);

  const handleCloseMarginModal = () => {
    setMarginModal(false);
    setSendAmount("");
  };
  const handleCloseFundingModal = () => {
    setFundingModal(false);
    setSendAmountFunding("");
    setReturnDate(null);
  };
  const handleCloseMarginSpotModal = () => {
    setMarginSpotModal(false);
    setSendAmountMargin("");
  };
  const handleCustomerFundingModalClose = () => setCustomerFundingModal(false);

  const validateNumber = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    getUserTransactionBalanceForOptions();
    getAssetsForOptionsMargin();

    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
      }
    };
  }, []);

  const getUserTransactionBalanceForOptions = () => {
    const uuid = localStorage.getItem("uuid");
    if (!uuid) return;
    const url = `${OPTIONSMARGINURL}getMainWalletBalanceStream?uuid=${uuid}`;

    try {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
      }

      const es = new EventSource(url);
      eventSourceRef.current = es;

      es.onmessage = (event) => {
        try {
          const result = JSON.parse(event.data);
          const balanceList = result.userBalance || [];
          setMyBalanceListForOption(balanceList);
        } catch (e) {
          console.error("Error parsing balance event data:", e);
        }
      };

      es.onerror = () => {
        fetchBalancesFallback();
      };
    } catch (e) {
      fetchBalancesFallback();
    }
  };

  const fetchBalancesFallback = async () => {
    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };
    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data?.userBalanceList) {
        setMyBalanceListForOption(
          response.data.userBalanceList.map((b) => ({
            currency: b.currencyCode,
            currentBalance: b.closingBalance,
            currencyType: 2,
            currencyId: b.currencyId,
            isOptionsMargin: 1,
            isOptionsFunding: 1,
          }))
        );
      }
    } catch (err) {
      console.error("Fallback balance fetch error:", err);
    }
  };

  const getAssetsForOptionsMargin = () => {
    const token = localStorage.getItem("access_token");
    if (!token) return;
    axios
      .get(`${OPTIONSMARGINURL}fundingHomeView`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + token,
        },
      })
      .then((response) => {
        const data = response.data;
        const currenciesCross = data.P_OPTIONS_MARGIN_CURRENCY || [];
        const currenciesFunding = data.P_FUNDING_CURRENCY || [];

        const arrCross = currenciesCross.filter((item) => item.CURRENCY_TYPE !== 1);
        const arrFunding = currenciesFunding.filter((item) => item.CURRENCY_TYPE !== 1);

        setFundingHomeViewCrossForOption(arrCross);
        setFundingHomeViewFundingForOption(arrFunding);
      })
      .catch((error) => {
        console.error("Error fetching options margin assets:", error);
      });
  };

  const handleChangeCurrency = (event) => {
    setCurrency(event.target.value);
    const currName = event.target.value?.CURRENCY_NAME;
    fetchMarginBalanceForCurrency(currName);
  };

  const fetchMarginBalanceForCurrency = (currName) => {
    if (!currName) return;
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");
    const url = `${OPTIONSMARGINURL}getMarginWalletByCurrency?uuid=${uuid}&currencyName=${currName}&marginType=2&leverage=2`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + accessToken,
        },
      })
      .then((response) => {
        const responsemargin = response.data;
        if (responsemargin.error !== 1) {
          setMarginWalletBalanceForOption(
            parseFloat(responsemargin.marginWalletBalance || 0).toFixed(6)
          );
          setUsedBalanceForOption(responsemargin.usedBalance || 0);
          setAvailableBalanceForOption(
            parseFloat(responsemargin.availableBalance || 0).toFixed(6)
          );
          setMarginwalletIdForOption(responsemargin.marginWalletId);
          setCurrencyIdForOption(responsemargin.currencyId);
          setCryptoCurrencyForOption(responsemargin.currencyName);
        } else {
          setMarginWalletBalanceForOption(0);
          setUsedBalanceForOption(0);
          setAvailableBalanceForOption(0);
          showToast("error", `No Balance Available for ${currName}`);
        }
      })
      .catch((error) => {
        console.error("Error fetching margin wallet:", error);
      });
  };

  const handleCrossAssetSpotClick = (modalType, currentBalance, curName, curId = "") => {
    setFiatCurrencyId(curId);
    setAmount(currentBalance);
    setCryptoCurrency(curName);
    if (modalType === "margin") {
      setMarginModal(true);
    } else {
      setFundingModal(true);
    }
  };

  const handleTransferToMargin = () => {
    if (!sendAmount || Number(sendAmount) <= 0) {
      showToast("error", "Please enter a valid amount");
      return;
    }
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    const objdata = {
      uuid: uuid,
      amount: sendAmount,
      currencyId: fiatCurrencyId,
      baseCurrencyId: fiatCurrencyId,
      unitPrice: "0",
      marginType: 2,
      assetPair: cryptoCurrency?.toUpperCase(),
    };

    axios
      .post(`${OPTIONSMARGINURL}transferBalanceToMWB`, JSON.stringify(objdata), {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + accessToken,
        },
      })
      .then((response) => {
        const res = response.data;
        if (res.error === 1) {
          showToast("error", res.message || "Margin transfer not successful");
        } else {
          showToast("success", res.message || "Margin transfer successful");
          getUserTransactionBalanceForOptions();
          handleCloseMarginModal();
        }
      })
      .catch((error) => {
        console.error("Error while processing margin transfer:", error);
        showToast("error", "An error occurred");
      });
  };

  const cryptoholdingmarginForOption = (cur1, bal, curId, cryptomarginwltid) => {
    setCryptoCur(cur1);
    setAmount(bal);
    setCryptoid(curId ?? "");
    setCryptomarginwalletId(cryptomarginwltid);
    setMarginSpotModal(true);
  };

  const handleTransferMarginToSpot = () => {
    if (!sendAmountMargin || Number(sendAmountMargin) <= 0) {
      showToast("error", "Please enter a valid amount");
      return;
    }
    const cryptomargintowalletObj = {
      uuid: localStorage.getItem("uuid"),
      marginWalletId: cryptomarginwalletId,
      amount: Number(sendAmountMargin),
      currencyId: cryptoid,
      marginType: 2,
    };

    axios
      .post(
        `${OPTIONSMARGINURL}transferBalanceMarginToMainWallet`,
        JSON.stringify(cryptomargintowalletObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (result.error !== 0) {
          showToast("error", result.message);
        } else {
          showToast("success", result.message || "Transfer to spot successful");
          getUserTransactionBalanceForOptions();
          if (currency) fetchMarginBalanceForCurrency(currency?.CURRENCY_NAME);
          handleCloseMarginSpotModal();
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        showToast("error", "An error occurred. Please try again.");
      });
  };

  const handleFundSubmit = async () => {
    if (!sendAmountFunding || Number(sendAmountFunding) <= 0) {
      showToast("error", "Please enter a valid amount");
      return;
    }
    const objdata = {
      uuid: localStorage.getItem("uuid"),
      amount: sendAmountFunding,
      currencyId: fiatCurrencyId,
      baseCurrencyId: fiatCurrencyId,
      unitPrice: 50,
      returnDate: returnDate ? dayjs(returnDate).format("DD-MM-YYYY") : "",
      assetPair: cryptoCurrency?.toUpperCase(),
    };

    try {
      const response = await axios.post(
        `${OPTIONSMARGINURL}transferFund`,
        JSON.stringify(objdata),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.returnId !== 1) {
        showToast("error", response.data.message);
      } else {
        showToast("success", "Funding successful");
        getUserTransactionBalanceForOptions();
        handleCloseFundingModal();
      }
    } catch (error) {
      console.error("Funding failed:", error);
      showToast("error", "An error occurred while funding");
    }
  };

  const handleViewFundingsSubmit = async () => {
    if (!assetCurrency) {
      showToast("error", "Please select an asset");
      return;
    }
    if (!assetFromDate || !assetToDate) {
      showToast("error", "Please select both from date and to date");
      return;
    }
    if (dayjs(assetFromDate).isAfter(dayjs(assetToDate))) {
      showToast("error", "To Date must be greater than from date");
      return;
    }

    const objdatafund = {
      uuid: localStorage.getItem("uuid"),
      currencyId: assetCurrency,
      fromDate: dayjs(assetFromDate).format("DD-MM-YYYY"),
      toDate: dayjs(assetToDate).format("DD-MM-YYYY"),
    };

    try {
      const response = await axios.post(
        `${OPTIONSMARGINURL}fundingViewByInputValue`,
        JSON.stringify(objdatafund),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      const list = response.data?.fundingHomeResponseDtoList || [];
      const arr = list.map((item) => ({
        currencyName: item.currencyName,
        lendingDate: item.lendingDate,
        returnDate: item.returnDate,
        amount: parseFloat(item.amount || 0).toFixed(6),
      }));
      setFundingData(arr);
      setCustomerFundingModal(true);
    } catch (error) {
      console.error("Funding search error:", error);
      showToast("error", "Error loading funding records");
    }
  };

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "var(--body-color)",
        color: "var(--text-color)",
      }}
    >
      {/* ── Top Header Bar ── */}
      <div
        className="bs-tabs-wrap"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "6px 10px",
          borderBottom: "1px solid rgba(125,125,125,0.15)",
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span
            style={{
              fontWeight: 700,
              fontSize: "11px",
              letterSpacing: "0.02em",
              textTransform: "uppercase",
              color: "var(--text-color)",
            }}
          >
            Crypto Holdings
          </span>
          <InfoIcon
            style={{ cursor: "pointer", color: "#a8a1a1", fontSize: "14px" }}
            onClick={() => handleInfoModal(1)}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <ContainedButton
            size="small"
            sx={{
              backgroundColor: themeBtnColor,
              color: "#fff",
              fontSize: "11px",
              fontWeight: 700,
              px: 1.2,
              py: 0.3,
              minWidth: "auto",
              boxShadow: "none",
            }}
          >
            CROSS
          </ContainedButton>
          <InfoIcon
            style={{ cursor: "pointer", color: "#a8a1a1", fontSize: "16px" }}
            onClick={() => handleInfoModal(0)}
          />
        </div>
      </div>

      {/* ── Sub-tabs navigation bar (Spot Wallet, Margin, View My Fundings) ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 1.5,
          py: 0.5,
          borderBottom: "1px solid rgba(125,125,125,0.12)",
          backgroundColor: "var(--body-color-less)",
          gap: 0.6,
          flexShrink: 0,
        }}
      >
        {assetLabels.map((lbl, idx) => {
          const isTabActive = assetTab === lbl;
          return (
            <Button
              key={lbl}
              size="small"
              onClick={() => {
                setAssetTab(lbl);
                setCurrency("");
                setMarginWalletBalanceForOption(0);
                setUsedBalanceForOption(0);
                setAvailableBalanceForOption(0);
                setAssetCurrency("");
                setAssetFromDate(null);
                setAssetToDate(null);
              }}
              sx={{
                py: 0.3,
                px: 1.1,
                fontSize: "10.5px",
                fontWeight: isTabActive ? 700 : 500,
                textTransform: "none",
                borderRadius: "4px",
                backgroundColor: isTabActive ? "rgba(125,125,125,0.14)" : "transparent",
                color: isTabActive ? themeBtnColor : "rgba(180, 185, 195, 0.75)",
                borderBottom: isTabActive ? `2px solid ${themeBtnColor}` : "2px solid transparent",
                "&:hover": {
                  color: themeBtnColor,
                  backgroundColor: "rgba(125,125,125,0.1)",
                },
              }}
            >
              {lbl}
              <InfoIcon
                sx={{ fontSize: "10px", ml: 0.4, cursor: "pointer", opacity: 0.6 }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleInfoModal(2 + idx);
                }}
              />
            </Button>
          );
        })}
      </Box>

      {/* ── Main Content Area ── */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          p: 1.5,
          backgroundColor: "var(--body-color-less)",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: "4px", height: "4px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(125,125,125,0.3)",
            borderRadius: "4px",
          },
        }}
      >
        {assetTab === "SPOT WALLET" && (
          <TableContainer sx={{ overflowX: "auto", width: "100%" }}>
            <Table size="small" sx={{ minWidth: 260 }}>
              <TableHead sx={{ backgroundColor: "var(--body-color-less2)" }}>
                <TableRow
                  sx={{
                    "& th": {
                      fontSize: "10px",
                      py: 0.6,
                      px: 1,
                      fontWeight: 700,
                      color: "rgba(180,185,195,0.85)",
                      borderBottom: "1px solid rgba(125,125,125,0.12)",
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  {AssetSpotColumn.map((col, i) => (
                    <TableCell key={i} align={i === 2 ? "right" : "left"}>
                      {col}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {myBalanceListForOption.length > 0 ? (
                  myBalanceListForOption
                    .filter((b) => b.currencyType === 2 || !b.currencyType)
                    .map((b, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          "& td": {
                            fontSize: "11px",
                            py: 0.75,
                            px: 1,
                            borderBottom: "1px solid rgba(125,125,125,0.08)",
                            color: "var(--text-color)",
                          },
                        }}
                      >
                        <TableCell sx={{ fontWeight: 600 }}>{b.currency}</TableCell>
                        <TableCell>{b.currentBalance}</TableCell>
                        <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                          <Button
                            size="small"
                            variant="contained"
                            onClick={() =>
                              handleCrossAssetSpotClick(
                                "margin",
                                b.currentBalance,
                                b.currency,
                                b.currencyId
                              )
                            }
                            sx={{
                              fontSize: "10px",
                              fontWeight: 700,
                              px: 1,
                              py: 0.2,
                              minHeight: 0,
                              backgroundColor: themeBtnColor,
                              textTransform: "none",
                              mr: 0.5,
                              boxShadow: "none",
                            }}
                          >
                            Margin
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() =>
                              handleCrossAssetSpotClick(
                                "funding",
                                b.currentBalance,
                                b.currency,
                                b.currencyId
                              )
                            }
                            sx={{
                              fontSize: "10px",
                              fontWeight: 700,
                              px: 1,
                              py: 0.2,
                              minHeight: 0,
                              borderColor: themeBtnColor,
                              color: themeBtnColor,
                              textTransform: "none",
                            }}
                          >
                            Funding
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={3}
                      align="center"
                      sx={{
                        py: 2,
                        color: "rgba(180,185,195,0.6)",
                        fontSize: "11px",
                        borderBottom: "none",
                      }}
                    >
                      No Crypto Balance
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {assetTab === "MARGIN" && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
            <FormControl size="small" fullWidth>
              <InputLabel sx={{ fontSize: "11px", color: "var(--text-color)" }}>
                Select Asset
              </InputLabel>
              <Select
                value={currency}
                label="Select Asset"
                onChange={handleChangeCurrency}
                sx={{
                  fontSize: "11px",
                  height: 32,
                  borderRadius: "4px",
                  backgroundColor: "var(--body-color-less2)",
                }}
              >
                {fundingHomeViewCrossForOption.map((d, i) => (
                  <MenuItem key={i} value={d} sx={{ fontSize: "11px" }}>
                    {d?.CURRENCY_NAME !== "BCC" ? d?.CURRENCY_NAME : "BCH"}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {currency && (
              <Box
                sx={{
                  fontSize: "11px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.8,
                  mt: 0.5,
                  p: 1.2,
                  backgroundColor: "var(--body-color-less2)",
                  borderRadius: "6px",
                  border: "1px solid rgba(125,125,125,0.12)",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span style={{ color: "rgba(180,185,195,0.8)" }}>Margin Wallet Balance:</span>
                  <span style={{ fontWeight: 700, color: upColor }}>
                    {marginWalletBalanceForOption}
                  </span>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span style={{ color: "rgba(180,185,195,0.8)" }}>Used Balance:</span>
                  <span style={{ fontWeight: 700 }}>{usedBalanceForOption}</span>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <span style={{ color: "rgba(180,185,195,0.8)" }}>Available Balance:</span>
                  <span style={{ fontWeight: 700, color: upColor }}>
                    {availableBalanceForOption}
                  </span>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mt: 0.5 }}>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() =>
                      cryptoholdingmarginForOption(
                        cryptoCurrencyForOption,
                        marginWalletBalanceForOption,
                        currencyIdForOption,
                        marginwalletIdForOption
                      )
                    }
                    sx={{
                      fontSize: "10px",
                      backgroundColor: themeBtnColor,
                      textTransform: "none",
                      fontWeight: 700,
                      borderRadius: "4px",
                      boxShadow: "none",
                      py: 0.3,
                      mr: 0.5,
                    }}
                  >
                    Transfer To Spot
                  </Button>
                  <InfoIcon
                    sx={{ fontSize: "11px", cursor: "pointer", opacity: 0.6, verticalAlign: "middle" }}
                    onClick={() => handleInfoModal(5)}
                  />
                </Box>
              </Box>
            )}
          </Box>
        )}

        {assetTab === "VIEW MY FUNDINGS" && (
          <Box sx={{ p: 0.5, display: "flex", flexDirection: "column", gap: 1 }}>
            <FormControl size="small" fullWidth>
              <InputLabel sx={{ fontSize: "11px", color: "var(--text-color)" }}>
                Select Asset
              </InputLabel>
              <Select
                value={assetCurrency}
                label="Select Asset"
                onChange={(e) => setAssetCurrency(e.target.value)}
                sx={{
                  fontSize: "11px",
                  height: 32,
                  borderRadius: "4px",
                  backgroundColor: "var(--body-color-less2)",
                }}
              >
                {fundingHomeViewFundingForOption.map((d, i) => (
                  <MenuItem key={i} value={d?.CURRENCYID} sx={{ fontSize: "11px" }}>
                    {d?.CURRENCY_NAME !== "BCC" ? d?.CURRENCY_NAME : "BCH"}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ display: "flex", gap: 1 }}>
                <DatePicker
                  format="DD-MM-YYYY"
                  value={assetFromDate}
                  onChange={(nv) => setAssetFromDate(nv)}
                  slots={{ openPickerIcon: CalendarMonthIcon }}
                  slotProps={{
                    textField: {
                      size: "small",
                      placeholder: "From Date",
                      fullWidth: true,
                      sx: {
                        "& .MuiInputBase-root": {
                          height: 32,
                          fontSize: "11px",
                          backgroundColor: "var(--body-color-less2)",
                          borderRadius: "4px",
                        },
                        "& .MuiSvgIcon-root": { fontSize: 16 },
                      },
                    },
                  }}
                />
                <DatePicker
                  format="DD-MM-YYYY"
                  value={assetToDate}
                  onChange={(nv) => setAssetToDate(nv)}
                  slots={{ openPickerIcon: CalendarMonthIcon }}
                  slotProps={{
                    textField: {
                      size: "small",
                      placeholder: "To Date",
                      fullWidth: true,
                      sx: {
                        "& .MuiInputBase-root": {
                          height: 32,
                          fontSize: "11px",
                          backgroundColor: "var(--body-color-less2)",
                          borderRadius: "4px",
                        },
                        "& .MuiSvgIcon-root": { fontSize: 16 },
                      },
                    },
                  }}
                />
              </Box>
            </LocalizationProvider>

            <Button
              size="small"
              variant="contained"
              onClick={handleViewFundingsSubmit}
              sx={{
                backgroundColor: themeBtnColor,
                fontSize: "11px",
                py: 0.5,
                textTransform: "none",
                fontWeight: 700,
                borderRadius: "4px",
                boxShadow: "none",
              }}
            >
              View Fundings
            </Button>
          </Box>
        )}
      </Box>

      {/* ── MODALS ── */}

      {/* 1. Margin Modal (Spot -> Margin) */}
      <ModalContent open={marginModal} onClose={handleCloseMarginModal} title="Transfer to Margin">
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
            <span>Available Balance:</span>
            <span style={{ fontWeight: 700 }}>
              {amount} {cryptoCurrency?.toUpperCase()}
            </span>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <span style={{ fontSize: "12px", opacity: 0.8 }}>Send Amount:</span>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid rgba(125,125,125,0.25)",
                backgroundColor: "var(--body-color-less)",
                color: "var(--text-color)",
              }}
              value={sendAmount}
              onChange={(e) => setSendAmount(e.target.value)}
              onKeyDown={validateNumber}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
            <OutlinedButton variant="outlined" onClick={handleCloseMarginModal}>
              Cancel
            </OutlinedButton>
            <ContainedButton
              variant="contained"
              disabled={!sendAmount || Number(sendAmount) <= 0 || Number(sendAmount) > Number(amount)}
              onClick={handleTransferToMargin}
            >
              Transfer
            </ContainedButton>
          </Box>
        </Box>
      </ModalContent>

      {/* 2. Transfer to Spot Modal (Margin -> Spot) */}
      <ModalContent open={marginSpotModal} onClose={handleCloseMarginSpotModal} title="Transfer to Spot Wallet">
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
            <span>Available Margin:</span>
            <span style={{ fontWeight: 700 }}>
              {amount} {cryptoCur?.toUpperCase()}
            </span>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <span style={{ fontSize: "12px", opacity: 0.8 }}>Send Amount:</span>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid rgba(125,125,125,0.25)",
                backgroundColor: "var(--body-color-less)",
                color: "var(--text-color)",
              }}
              value={sendAmountMargin}
              onChange={(e) => setSendAmountMargin(e.target.value)}
              onKeyDown={validateNumber}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
            <OutlinedButton variant="outlined" onClick={handleCloseMarginSpotModal}>
              Cancel
            </OutlinedButton>
            <ContainedButton
              variant="contained"
              disabled={!sendAmountMargin || Number(sendAmountMargin) <= 0 || Number(sendAmountMargin) > Number(amount)}
              onClick={handleTransferMarginToSpot}
            >
              Transfer
            </ContainedButton>
          </Box>
        </Box>
      </ModalContent>

      {/* 3. Funding Modal */}
      <ModalContent open={fundingModal} onClose={handleCloseFundingModal} title="Create Funding">
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
            <span>Available Balance:</span>
            <span style={{ fontWeight: 700 }}>
              {amount} {cryptoCurrency?.toUpperCase()}
            </span>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <span style={{ fontSize: "12px", opacity: 0.8 }}>Send Amount:</span>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid rgba(125,125,125,0.25)",
                backgroundColor: "var(--body-color-less)",
                color: "var(--text-color)",
              }}
              value={sendAmountFunding}
              onChange={(e) => setSendAmountFunding(e.target.value)}
              onKeyDown={validateNumber}
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <span style={{ fontSize: "12px", opacity: 0.8 }}>Return Date:</span>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD-MM-YYYY"
                value={returnDate}
                onChange={(nv) => setReturnDate(nv)}
                slots={{ openPickerIcon: CalendarMonthIcon }}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    sx: {
                      "& .MuiInputBase-root": {
                        height: 36,
                        backgroundColor: "var(--body-color-less)",
                        borderRadius: "6px",
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
            <OutlinedButton variant="outlined" onClick={handleCloseFundingModal}>
              Cancel
            </OutlinedButton>
            <ContainedButton
              variant="contained"
              disabled={!sendAmountFunding || Number(sendAmountFunding) <= 0 || !returnDate}
              onClick={handleFundSubmit}
            >
              Submit Funding
            </ContainedButton>
          </Box>
        </Box>
      </ModalContent>

      {/* 4. Customer Funding Details Modal */}
      <ModalContent
        open={customerFundingModal}
        onClose={handleCustomerFundingModalClose}
        title="My Funding Details"
      >
        <Box sx={{ p: 1.5, maxHeight: "350px", overflowY: "auto" }}>
          {fundingData.length > 0 ? (
            <Table size="small">
              <TableHead>
                <TableRow sx={{ "& th": { fontWeight: 700, fontSize: "11px", color: "var(--text-color)" } }}>
                  <TableCell>Asset</TableCell>
                  <TableCell>Lending Date</TableCell>
                  <TableCell>Return Date</TableCell>
                  <TableCell align="right">Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fundingData.map((row, idx) => (
                  <TableRow key={idx} sx={{ "& td": { fontSize: "11px", color: "var(--text-color)" } }}>
                    <TableCell>{row.currencyName}</TableCell>
                    <TableCell>{row.lendingDate}</TableCell>
                    <TableCell>{row.returnDate}</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600, color: upColor }}>
                      {row.amount}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Typography sx={{ textAlign: "center", py: 3, fontSize: "12px", opacity: 0.7 }}>
              No funding records found for selected period.
            </Typography>
          )}
        </Box>
      </ModalContent>

      {/* 5. Info Popup */}
      <InfoPopUp
        open={infoModal}
        onClose={handleCloseInfoModal}
        title={Infomodal[infoIndex]?.title}
        description={Infomodal[infoIndex]?.description}
      />
    </Box>
  );
};

export default OptionMarginHoldings;
